import { ResourceOperations, ResourceTypes } from 'authentication/resources';
import { OmnibarEntry } from '../omnibar-interfaces';

const functions: OmnibarEntry[] = [
  {
    id: '9d0358c6-4dfc-4079-b062-8c8784357a3c',
    label: 'Udbakke',
    keywords: ['sendte breve', 'post'],
    context: 'none',
    group: 'Udbakke',
    url: '/outbox',
    resourceActions: [{ resourceOperation: ResourceOperations.Read, resourceType: ResourceTypes.SystemOutbox }],
  },
];

export default functions;
